// https://github.com/klaxit/cookie-consent

window.analyticsInjected = false

if (navigator.doNotTrack != 1) {
	cc = new window.CookieConsent({
		title: 'We use cookies 🍪',
	})
	cc.on('change', checkAnalytics)

	checkAnalytics()
	if (cc.status !== 'accepted' && cc.status !== 'rejected') {
		cc.open()
	}

	function checkAnalytics() {
		if (window.CookieConsent.acceptedCategories.includes('analytics') && window.analyticsInjected == false) {
			window.analyticsInjected = true

			// Google analytics
			el = document.createElement('script')
			el.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-43743206-1')
			document.head.appendChild(el)

			el = document.createElement('script')
			el.text = "window.dataLayer = window.dataLayer || [];"+
			"function gtag(){dataLayer.push(arguments);}"+
			"gtag('js', new Date());"+
			"gtag('config', 'UA-43743206-1');"
			document.head.appendChild(el)

			// Google analytics ga4
			el = document.createElement('script')
			el.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-LF8DLRGF8P')
			document.head.appendChild(el)

			el = document.createElement('script')
			el.text = "window.dataLayer = window.dataLayer || [];"+
			"function gtag(){dataLayer.push(arguments);}"+
			"gtag('js', new Date());"+
			"gtag('config', 'G-LF8DLRGF8P');"
			document.head.appendChild(el)

			// pinterest
			el = document.createElement('script')
			el.text = "!function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(Array.prototype.slice.call(arguments))};"+
			"var n=window.pintrk;n.queue=[],n.version='3.0';"+
			"var t=document.createElement('script');t.async=!0,t.src=e;"+
			"var r=document.getElementsByTagName('script')[0];r.parentNode.insertBefore(t,r)}}('https://s.pinimg.com/ct/core.js');pintrk('load','2613511064580',{em:'<user_email_address>'});pintrk('page');pintrk('track','pagevisit');"
			document.head.appendChild(el)

			// Hotjar
			el = document.createElement('script')
			el.text = "(function(h,o,t,j,a,r){"+
			"h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};"+
			"h._hjSettings={hjid:2419076,hjsv:6};"+
			"a=o.getElementsByTagName('head')[0];"+
			"r=o.createElement('script');r.async=1;"+
			"r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;"+
			"a.appendChild(r);"+
			"})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');"
			document.head.appendChild(el)
		}
	}
}
